document.addEventListener('DOMContentLoaded', function () {
  // 🔹 Blur nav links on mouseup
  document.querySelectorAll('.custom-navbar__menu .nav-link').forEach(link => {
    link.addEventListener('mouseup', () => {
      link.blur();
    });
  });

  // 🔹 Sticky with smooth hide after scroll
  const navbar = document.querySelector('.custom-navbar');
  const scrollThreshold = 1000;

  function updateNavbarSticky() {
    if (!navbar) return;

    const isDesktop = window.innerWidth > 900;

    if (isDesktop && window.scrollY < scrollThreshold) {
      navbar.classList.add('is-sticky');
      navbar.classList.remove('unstuck');
    } else {
      // ✅ Keep .is-sticky for sticky behavior & transition
      navbar.classList.add('unstuck');
      // ⛔ Don't remove .is-sticky immediately
    }
  }

  // Initial check
  updateNavbarSticky();

  // Update on scroll and resize
  window.addEventListener('scroll', updateNavbarSticky);
  window.addEventListener('resize', updateNavbarSticky);
});
